module.exports = __webpack_public_path__ + "static/media/brand-16.6825849c.png";